import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import SettingsTabs from "../components/tables/SettingsTabs";

export default function SettingsPage() {
    return (
        <>
            <PageMeta
                title="Settings | Shoplattice Admin Dashboard"
                description="Manage System Settings"
            />
            <PageBreadcrumb pageTitle="Settings" />
            <div className="space-y-6">
                <SettingsTabs />
            </div>
        </>
    );
}
